import { APP_ROUTES } from "const";
import { useSignUpApi } from "hooks";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FIELD_NAMES } from "./SignUpForm.constants";

export function useInitialState() {
  return useMemo(() => {
    return {
      [FIELD_NAMES.FIRST_NAME]: "",
      [FIELD_NAMES.LAST_NAME]: "",
      [FIELD_NAMES.EMAIL]: "",
      [FIELD_NAMES.PASSWORD]: "",
    };
  }, []);
}

export function useSubmitHandler() {
  const { mutateAsync } = useSignUpApi({});
  const navigate = useNavigate();
  return useCallback(
    async (props, formikHelpers) => {
      try {
        const email = props.email.toLowerCase();
        await mutateAsync({
          ...props,
          email,
        });
        navigate(
          `${APP_ROUTES.VERIFY_OTP}?email=${encodeURIComponent(email)}`,
          { state: { email } }
        );
      } catch (error: any) {
        const data = error?.response?.data;
        if (data && typeof data === "object") {
          formikHelpers.setErrors(data);
        } else {
          formikHelpers.setErrors({
            [FIELD_NAMES.EMAIL]:
              error?.message || "Something went wrong. Please try again.",
          });
        }
      } finally {
        formikHelpers.setSubmitting(false);
      }
    },
    [mutateAsync, navigate]
  );
}
